import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
import _Set from "@babel/runtime-corejs3/core-js/set";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import React from "react";
import { variables as breakpoints } from "@xo-union/tk-ui-breakpoints";
import { descendingOrderViewportCompare, descendingOrderPixelDensityCompare } from "../compareFunctions/index.js";
import isSourceNode from "../isSourceNode/index.js";
import createMediaQuery from "../createMediaQuery.js";
const units = {
  px: num => `${num}px`,
  dpi: num => `${num}dpi`
};

const dpiForPixelDensity = pixelRatio => pixelRatio * 96;

const getNextLargest = (descendingOrderSortedList, target) => {
  const targetIndex = _indexOfInstanceProperty(descendingOrderSortedList).call(descendingOrderSortedList, target) - 1;
  return descendingOrderSortedList[targetIndex];
};
/**
 * Utility processes props and returns utility functions used to create a mutually
 * exclusive set of media queries for a given source
 */


export const mutexMediaQueryFactory = props => {
  var _context, _context2, _context3;

  const givenPixelDensities = new _Set(props.pixelDensities);
  const givenViewports = new _Set();

  _forEachInstanceProperty(_context = React.Children).call(_context, props.children, child => {
    if (isSourceNode(child)) {
      if (child.props.pixelDensity) {
        givenPixelDensities.add(child.props.pixelDensity);
      }

      givenViewports.add(child.props.viewport);
    }
  });

  if (props.preload && !givenViewports.has('xs')) {
    // eslint-disable-next-line no-console
    console.warn('[@xo-union/tk-component-picture]: Preload is enabled yet there is no source with a `viewport="xs"`. This will cause the browser to fallback to the `img` element, which is not preloaded. Please specify a Source with a `viewport="xs"`');
  }

  const descendingOrderSortedViewports = _sortInstanceProperty(_context2 = _Array$from(givenViewports)).call(_context2, descendingOrderViewportCompare);

  const descendingOrderSortedPixelDensities = _sortInstanceProperty(_context3 = _Array$from(givenPixelDensities)).call(_context3, descendingOrderPixelDensityCompare);

  const getMaxPixelDensity = pixelDensity => getNextLargest(descendingOrderSortedPixelDensities, pixelDensity);

  const getMaxViewport = viewport => getNextLargest(descendingOrderSortedViewports, viewport);

  const getWidthBoundaries = viewport => {
    const maxViewport = getMaxViewport(viewport);
    const minWidth = units.px(breakpoints.ranges[viewport].min);
    const maxWidth = maxViewport && units.px(breakpoints.ranges[maxViewport].min - 0.02);
    return {
      minWidth,
      maxWidth
    };
  };

  const getResolutionBoundaries = pixelDensity => {
    const maxPixelDensity = getMaxPixelDensity(pixelDensity);
    const minResolution = units.dpi(dpiForPixelDensity(pixelDensity));
    const maxResolution = maxPixelDensity && units.dpi(dpiForPixelDensity(maxPixelDensity) - 1);
    return {
      minPixelDensity: pixelDensity,
      maxPixelDensity: maxPixelDensity - 0.1,
      minResolution,
      maxResolution
    };
  };

  const createMutexMediaQuery = _ref => {
    let {
      pixelDensity,
      viewport
    } = _ref;
    return createMediaQuery({ ...getWidthBoundaries(viewport),
      ...getResolutionBoundaries(pixelDensity)
    });
  };

  return createMutexMediaQuery;
};
export const createNonExclusiveMediaQuery = _ref2 => {
  let {
    pixelDensity,
    viewport
  } = _ref2;
  const minWidth = units.px(breakpoints.ranges[viewport].min);
  const minResolution = pixelDensity && units.dpi(dpiForPixelDensity(pixelDensity));
  const minPixelDensity = pixelDensity;
  return createMediaQuery({
    minWidth,
    minResolution,
    minPixelDensity
  });
};